import { type FC, useState } from 'react';

import classNames from 'classnames';

import { EyeIconOff } from '../SVGIcons/EyeIconOff';
import { EyeIconOn } from '../SVGIcons/EyeIconOn';

import { type FormInputProps, FormInput } from './FormInput';
import styles from './PasswordInput.module.scss';

export const PasswordInput: FC<Omit<FormInputProps, 'type'>> = (props) => {
  const [isVisible, setIsVisible] = useState(false);

  const toggleVisibility = () => setIsVisible((curr) => !curr);

  return (
    <div className={styles.wrapper}>
      <FormInput
        data-testid="password-input"
        type={isVisible ? 'text' : 'password'}
        {...props}
        className={classNames(props.className, { [styles.sm]: props.size === 'sm' })}
      />
      <button
        className={classNames(styles.toggleButton, {
          [styles.toggleButtonIconOff]: isVisible,
          [styles.sm]: props.size === 'sm',
        })}
        type="button"
        onClick={toggleVisibility}
      >
        {isVisible ? <EyeIconOff /> : <EyeIconOn />}
      </button>
    </div>
  );
};
